<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="card card-blue">
                    <div class="row hide">
                        <div class="col-md-12">
                            <div class="card card-shadow printableArea" id="printMe">
                                <div class="card-header border-bottom">
                                    <div class="d-md-flex align-items-center m-t-20">
                                        <div class="d-flex align-items-center">
                                            <div>
                                                <h4 class="card-title">{{challan.number}} </h4>
                                                <h6 class="text-muted m-t-5">Date {{challan.created_at | date}}</h6>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="card-blue card-body">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <h5 class="font-bold text-muted">Seller</h5>
                                            <h4 class="m-t-5">{{currentOrg.name}}</h4>
                                            <p class="text-normal">
                                                {{challan.seller_address.line1}}, &nbsp;{{challan.seller_address.line2}}<br>
                                                {{challan.seller_address.country}},&nbsp;{{challan.seller_address.city}}<br>
                                                {{challan.seller_address.state}},&nbsp;{{challan.seller_address.postal_code}}<br>
                                                <i class="fas fa-phone"></i>&nbsp;{{currentOrg.biz_phone}}<br>
                                                <i class="fas fa-envelope"></i>&nbsp;{{currentOrg.biz_email}}<br>
                                            </p>
                                        </div>

                                        <div class="col-md-4">
                                            <h5 class="font-bold text-muted">Details</h5>
                                            <h4 class="m-t-5">{{challan.number}}</h4>
                                            <p lass="text-normal">
                                                <b>Created At : </b> {{challan.created_at | date}}<br>
                                                <b>Created By : </b> {{challan.email }}<br>
                                                <b>Status : </b> {{challan.status }}<br>
                                                <b>Reference : </b> {{challan.reference }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-8">
                                            <h5 class="font-bold text-muted">Details</h5>
                                            <h4 class="m-t-5">{{challan.buyer}}</h4>
                                            <p class="text-normal">
                                                {{challan.buyer_address.line1}},&nbsp;{{challan.buyer_address.line2}}<br>
                                                {{challan.buyer_address.country}},&nbsp;{{challan.buyer_address.city}}<br>
                                                {{challan.buyer_address.state}},&nbsp;{{challan.buyer_address.postal_code}}<br>
                                                <i class="fas fa-phone"></i>&nbsp;{{challan.buyer_phone}}<br>
                                                <i class="fas fa-envelope"></i>&nbsp;{{challan.buyer_email}}<br>
                                            </p>
                                        </div>

                                        <div class="col-md-4" v-if="challan.warehouse">
                                            <h5 class="font-bold text-muted">Warehouse</h5>
                                            <h4 class="m-t-5">{{challan.warehouse.name}}</h4>
                                            <p class="text-normal">
                                                {{challan.warehouse_address.line1}}, &nbsp;{{challan.warehouse_address.line2}}<br>
                                                {{challan.warehouse_address.country}},&nbsp;{{challan.warehouse_address.city}}<br>
                                                {{challan.warehouse_address.state}},&nbsp;{{challan.warehouse_address.postal_code}}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="row m-t-20" v-if="challan.items.length>0">
                                        <div class="col-md-12">
                                            <h5 class="font-bold text-muted">Items</h5>
                                        </div>

                                        <div class="col-md-12">
                                            <div class="table-responsive" style="clear: both;">
                                                <table class="table table-bordered font-10" style="font-size: small;">
                                                    <thead class="text-center">
                                                    <tr>
                                                        <th class="p-1 font-weight-bold text-right">#</th>
                                                        <th class="p-1 font-weight-bold">Name</th>
                                                        <th class="p-1 font-weight-bold">Quantity</th>
                                                        <th class="p-1 font-weight-bold">Rate</th>
                                                        <th class="p-1 font-weight-bold">Total</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr v-for="(item,index) in challan.items">
                                                        <td class="p-1 text-right">{{index+1}}</td>
                                                        <td class="p-1">{{item.name}} - {{item.variety}}</td>
                                                        <td class="p-1 text-right">{{item.quantity| unitFix(2)}}
                                                            {{item.symbol}}
                                                        </td>
                                                        <td class="p-1 text-right">{{currentOrg.currency_symbol}}
                                                            {{item.rate | unitFix(2)}}
                                                        </td>
                                                        <td class="p-1 text-right">{{currentOrg.currency_symbol}}
                                                            {{item.sub_total | unitFix(2)}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="p-1 text-right font-weight-bold" colspan="4">Total
                                                        </td>
                                                        <td class="p-1 text-right">{{currentOrg.currency_symbol}}
                                                            {{challan.total | unitFix(2)}}
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td class="p-2 text-right font-weight-bold" colspan="5">
                                                            {{currentOrg.currency_symbol}} {{ challan.total | unitFix(2)
                                                            | words}} Only
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="card-header mt-3">
                        <h4 class="card-title">{{challan.number}}
                            <span :class="{
                                            'label-info' : challan.status === 'DRAFT' ,
                                            'label-success' : challan.status === 'CONFIRMED' ,
                                            'label-inverse' : challan.status === 'INVOICED'
                                            }"
                                  class="label font-weight-bold">
                                <template v-if="challan.status === 'DRAFT'">Draft</template>
                                <template v-if="challan.status === 'CONFIRMED'">Confirmed</template>
                                <template v-if="challan.status === 'INVOICED'">Invoiced</template>
                            </span>
                        </h4>
                    </div>
                    <div class="card-body">
                        <div class="form-group row mb-0">
                            <label class="control-label text-right col-md-3">Challan Number :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">{{challan.number}}</p>
                            </div>

                            <label class="control-label text-right col-md-3">Buyer :</label>
                            <div class="col-md-9">
                                <p class="form-control-static mb-0">{{challan.buyer}}</p>
                                <p class="mb-0">
                                    {{challan.buyer_address.line1}}{{challan.buyer_address.line2?','+challan.buyer_address.line1:''}}
                                </p>
                                <p class="mb-0">
                                    {{challan.buyer_address.city}}, {{challan.buyer_address.state}}
                                </p>
                                <p>
                                    {{challan.buyer_address.country}}, {{challan.buyer_address.postal_code}}
                                </p>
                            </div>

                            <label class="control-label text-right col-md-3">Challan Reference :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">{{challan.reference}}</p>
                            </div>

                            <template v-if="currentOrg.role === 'ORG_ADMIN'">
                                <label class="control-label text-right col-md-3 mb-3">Invoice Number :</label>
                                <div class="col-md-9">
                                    <router-link
                                            :to="{name: 'viewmarketplaceinvoice', params: { invoiceid: challan.invoice_id }}"
                                            v-if="challan.invoice_id">
                                        {{challan.invoice_id | invoiceNumber}}
                                    </router-link>
                                    <p class="form-control-static" v-else>N/A</p>
                                </div>
                            </template>

                            <label class="control-label text-right col-md-3">Challan Status :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">
                                    <template v-if="challan.status === 'DRAFT'">Draft</template>
                                    <template v-if="challan.status === 'CONFIRMED'">Confirmed</template>
                                    <template v-if="challan.status === 'INVOICED'">Invoiced</template>
                                </p>
                            </div>

                            <label class="control-label text-right col-md-3" v-if="challan.warehouse">Warehouse
                                :</label>
                            <div class="col-md-9" v-if="challan.warehouse">
                                <p class="form-control-static mb-0">
                                    <router-link
                                            :to="{ name :'viewexpwarehouse' , params : { warehouseid: challan.warehouse.id } }"
                                            class="form-control-static">
                                        {{challan.warehouse.name}}
                                    </router-link>
                                </p>
                                <p class="mb-0">
                                    {{challan.warehouse_address.line1}}{{challan.warehouse_address.line2?','+challan.warehouse_address.line1:''}}
                                </p>
                                <p class="mb-0">
                                    {{challan.warehouse_address.city}}, {{challan.warehouse_address.state}}
                                </p>
                                <p>
                                    {{challan.warehouse_address.country}}, {{challan.warehouse_address.postal_code}}
                                </p>
                            </div>

                            <label class="control-label text-right col-md-3">Challan Items :</label>
                            <div class="col-md-6">
                                <table class="table t">
                                    <thead>
                                    <tr>
                                        <td class="p-2 font-weight-bold">#</td>
                                        <td class="p-2 font-weight-bold">Good</td>
                                        <td class="p-2 font-weight-bold text-right">Rate</td>
                                        <td class="p-2 font-weight-bold text-right">Quantity</td>
                                        <td class="p-2 font-weight-bold text-right">Subtotal</td>
                                    </tr>
                                    </thead>
                                    <tbody v-if="challan.items.length === 0">
                                    <tr>
                                        <td class="text-center font-weight-bold font-20"
                                            colspan="8">No records found
                                        </td>
                                    </tr>
                                    </tbody>
                                    <tbody v-else>
                                    <tr v-for="(item,i) in challan.items">
                                        <td class="p-2">{{i+1}}</td>
                                        <td class="p-2">{{item.name}}</td>
                                        <td class="p-2 text-right">{{currentOrg.currency_symbol}} {{item.rate |
                                            unitFix(2)}} / {{item.symbol}}
                                        </td>
                                        <td class="p-2 text-right">{{item.quantity | unitFix(2)}} {{item.symbol}}</td>
                                        <td class="p-2 text-right">{{currentOrg.currency_symbol}} {{item.sub_total |
                                            unitFix(2)}}
                                        </td>
                                    </tr>
                                    <tr class="border-bottom">
                                        <td class="p-2 text-right font-weight-bold" colspan="4">Total</td>
                                        <td class="p-2 text-right">{{currentOrg.currency_symbol}} {{challan.total |
                                            unitFix(2)}}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-3"/>

                            <label class="control-label text-right col-md-3">Challan Total :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">{{currentOrg.currency_symbol}} {{challan.total |
                                    unitFix(2)}}</p>
                            </div>

                            <label class="control-label text-right col-md-3">Created At :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">{{challan.created_at | timestamp}}</p>
                            </div>

                            <label class="control-label text-right col-md-3">Created By :</label>
                            <div class="col-md-9">
                                <p class="form-control-static">{{challan.email}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer text-right">
                        <div class="button-group">
                            <button @click="printInvoice" class="btn btn-info">Print</button>

                            <router-link :to="{ name: 'marketplaceeditchallan', params : { challaid : challanid }}"
                                         class="btn btn-primary"
                                         v-if="challan.status === 'DRAFT'">
                                Edit
                            </router-link>
                            <button class="btn btn-danger" data-target="#deleteModal" data-toggle="modal"
                                    v-if="challan.status === 'DRAFT'">
                                Delete
                            </button>
                            <button class="btn btn-success" data-target="#confirmModal" data-toggle="modal"
                                    v-if="challan.status === 'DRAFT'">Confirm
                            </button>
                            <button class="btn btn-success" data-target="#invoiceModal" data-toggle="modal"
                                    v-if="challan.status === 'CONFIRMED' && currentOrg.role === 'ORG_ADMIN'">Raise
                                Invoice
                            </button>
                        </div>
                    </div>

                    <div class="modal" id="confirmModal" role="dialog" tabindex="-1">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="card card-blue mb-0">
                                    <div class="card-body pt-5">
                                        <p class="text-center"><i
                                                class="fa fa-5x fa-exclamation-triangle text-warning"/></p>
                                        <h5 class="my-5">You are about to confirm challan <b class="text-info">{{challan.number}}</b>.
                                            You will no longer be able to edit this. Are you sure?</h5>
                                        <button @click="confirmChallan" class="btn btn-success float-left"
                                                type="button">
                                            Yes
                                        </button>
                                        <button aria-label="Close" class="btn btn-secondary float-right"
                                                data-dismiss="modal"
                                                type="button">
                                            No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal" id="deleteModal" role="dialog" tabindex="-1">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="card card-blue mb-0">
                                    <div class="card-body pt-5">
                                        <p class="text-center"><i
                                                class="fa fa-5x fa-exclamation-triangle text-warning"/></p>
                                        <h5 class="my-5">You are about to delete challan <b class="text-info">{{challan.number}}</b>.
                                            Are you sure?</h5>
                                        <button @click="deleteChallan" class="btn btn-success float-left" type="button">
                                            Yes
                                        </button>
                                        <button aria-label="Close" class="btn btn-secondary float-right"
                                                data-dismiss="modal"
                                                type="button">
                                            No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal" id="invoiceModal" role="dialog" tabindex="-1">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="card card-blue mb-0">
                                    <div class="card-body pt-5">
                                        <p class="text-center"><i
                                                class="fa fa-5x fa-exclamation-triangle text-warning"/></p>
                                        <h5 class="my-5">You are about to raise invoice against challan <b
                                                class="text-info">{{challan.number}}</b>. Are you sure?</h5>
                                        <button @click="invoiceChallan" class="btn btn-success float-left"
                                                type="button">
                                            Yes
                                        </button>
                                        <button aria-label="Close" class="btn btn-secondary float-right"
                                                data-dismiss="modal"
                                                type="button">
                                            No
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "MarketplaceViewChallan",
        props: ["challanid"],
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        data() {
            return {
                challan: {
                    items: [],
                    warehouse: {},
                    buyer_address: {},
                    seller_address: {},
                    warehouse_address: {}
                }
            }
        },
        mounted() {
            this.getChallan();
        },
        methods: {
            async getChallan() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.get(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}`);
                    this.challan = data;
                } catch (e) {
                    this.$toastr('error', 'Challan fetch failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                }
            },
            async confirmChallan() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}/confirm`);
                    await this.getChallan();
                    this.$toastr('success', 'Challan confirmed', 'Success');
                } catch (e) {
                    this.$toastr('error', 'Challan confirmation failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                    $("#confirmModal").modal('hide');
                }
            },
            async deleteChallan() {
                try {
                    $(".preloader").fadeIn();
                    await this.$http.delete(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}`);
                    this.$toastr('success', 'Challan deleted', 'Success');
                    await this.$router.push({name: 'marketplacechallans'});
                } catch (e) {
                    this.$toastr('error', 'Challan deletion failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                    $("#deleteModal").modal('hide');
                }
            },
            async invoiceChallan() {
                try {
                    $(".preloader").fadeIn();
                    let {data} = await this.$http.post(`/marketplaces/${this.currentOrg.marketplace_id}/challans/${this.challanid}/invoice`);
                    this.$toastr('success', 'Invoice created', 'Success');
                    $("#invoiceModal").modal('hide');
                    await this.$router.push({name: 'viewmarketplaceinvoice', params: {invoiceid: data.invoiceid}});
                } catch (e) {
                    this.$toastr('error', 'Invoice create failed', 'Failed');
                } finally {
                    $(".preloader").fadeOut();
                    $("#invoiceModal").modal('hide');
                }
            },
            printInvoice() {
                this.$htmlToPaper('printMe');
            },
        }
    }
</script>

<style scoped>

</style>
